/** 图形Gragh的数据，用于在JOINT中CTRL+Z/Y的缓存，因为仅仅JSON无法完全存储所有数据 */
/** 仅支持简单类型 */
export class GraghData {
  private _isModified = false; // 是否修改了，true代表当前版本已经修改，需要保存
  private _diagramDesignId: string; // 对应的Diagram的设计期ID
  private _graghJSON: any; // Gragh的JSON对象

  private constructor(isModified: boolean, diagramDesignId: string, graghJSON: any) {
    this._isModified = isModified;
    this._diagramDesignId = diagramDesignId;
    this._graghJSON = graghJSON;
  }

  /** 是否修改了，true代表当前版本已经修改，需要保存 */
  get isModified(): boolean {
    return this._isModified;
  }

  /** 对应的Diagram的设计期ID */
  get diagramDesignId(): string {
    return this._diagramDesignId;
  }

  /** Gragh的JSON对象 */
  get graghJSON(): any {
    return this._graghJSON;
  }

  /** 创建图形数据 */
  static CreateGraghData(isModified: boolean, diagramDesignId: string, graghJSON: any): GraghData {
    return new GraghData(isModified, diagramDesignId, graghJSON);
  }
}
